// extracted by mini-css-extract-plugin
export var active = "_2n-2";
export var highlight = "_2n-1";
export var highlightLayer = "_2n-0";
export var issuePopover = "_2n-3";
export var statusIcon = "_2n-4";